// extracted by mini-css-extract-plugin
module.exports = {"searchBarRoot":"uDzeOZbs","expanded":"llYo1Rao","expand":"nVI4_9ko","collapsed":"Z8X1R5g_","collapse":"AcDeLqrd","form":"BEDZtboe"};